export default __webpack_public_path__ + "static/Empreendimento-6cc6265113c96f052554a64d61e0bb73.svg";